import { useNavigate } from 'react-router-dom';
import { sectionPath } from '../siteRoutes';
import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useHotel } from '../context/HotelContext';
import { useLanguage } from '../context/LanguageContext';
import { faq as faqI18n } from '../i18n/faq';

const FAQ = () => {
  const navigate = useNavigate();
  const { faqs: dbFaqs } = useHotel();
  const { lang, t } = useLanguage();
  // Visible FAQ = the same localized Q&As the FAQPage schema announces (Google requires markup to match visible text);
  // the admin-managed English extras are appended on the English edition only.
  const localized = (faqI18n[lang] || faqI18n.en).map((e) => ({ question: e.q, answer: e.a }));
  const faqs = lang === 'en' ? [...localized, ...dbFaqs.filter((f) => !localized.some((l) => l.question.toLowerCase() === (f.question || '').toLowerCase()))] : localized;
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <p className="text-orange-500 font-semibold mb-2 text-sm uppercase tracking-wider">{t('faq.subtitle')}</p>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4 text-gray-900">{t('faq.title')}</h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">{t('faq.intro')}</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 hover:bg-gray-50 transition-colors"
                >
                  <span className="font-bold text-lg text-gray-900 pr-8">{faq.question}</span>
                  <ChevronDown 
                    size={24} 
                    className={`text-orange-500 flex-shrink-0 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <div 
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <div className="px-6 pb-5 pt-2">
                    <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Still have questions?</p>
          <button 
            onClick={() => { const el = document.getElementById('contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); else navigate(sectionPath('contact', window.location.pathname)); }}
            className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 py-3 rounded-full font-bold hover:from-orange-600 hover:to-orange-700 transition-all shadow-lg hover:shadow-xl"
          >
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;